//http://bgrins.github.io/spectrum/
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodColorPicker', sodColorPicker);

    function sodColorPicker($timeout, lodash) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                name: '@inputName',
                readonly: '=',
                disabled: '='
            },
            template: '<div class="color-picker-wrapper">' +
                '<input type="text" name="<%inputName%>" ng-readonly="readonly" ng-disabled="disabled" ng-disabled class="color-picker-dom" />' +
                '<input type="text" ng-model="displayModel" class="color-picker-value" ng-change="displayModelChange()" />' +
            '</div>',
            link: function(scope, elem, attr, ngModelCtrl) {
                var inputDom = elem.find('.color-picker-dom');
                var inputDomValue = elem.find('.color-picker-value');
                inputDom.spectrum({
                    preferredFormat: 'hex',
                    change: function(color) {
                        ngModelCtrl.$setViewValue(color.toHexString().toUpperCase());
                        scope.$apply(function() {
                            ngModelCtrl.$render();
                        });
                    },
                    move: function(color) {
                        // scope.displayModel = color.toHexString().toUpperCase();
                        // scope.$apply();

                        scope.displayModel = color.toHexString().toUpperCase();
                        ngModelCtrl.$setViewValue(color.toHexString().toUpperCase());
                        scope.$apply(function() {
                            ngModelCtrl.$render();
                        });
                    },
                    hide: function(color) {
                        if (scope.displayModel.length > 0) {
                            ngModelCtrl.$setViewValue(color.toHexString().toUpperCase());
                        } else {
                            ngModelCtrl.$setViewValue(null);
                        }

                        scope.$apply(function() {
                            ngModelCtrl.$render();
                        });
                    },
                    containerClassName: 'color-picker-container'
                });

                scope.displayModelChange = function() {
                    inputDom.spectrum('set', scope.displayModel.toUpperCase());
                    if (scope.displayModel.length > 0) {
                        ngModelCtrl.$setViewValue(scope.displayModel.toUpperCase());
                    } else {
                        ngModelCtrl.$setViewValue(null);
                    }
                    ngModelCtrl.$render();
                };

                inputDomValue.click(function(e) {
                    inputDom.spectrum('show');
                    return false;
                });

                ngModelCtrl.$render = function() {
                    scope.currentModel = ngModelCtrl.$viewValue || null;
                };

                $timeout(function() {
                    let currentModel = scope.currentModel;
                    if (!lodash.isEmpty(currentModel)) {
                        currentModel = currentModel.toUpperCase();
                    }
                    inputDom.spectrum('set',  currentModel);
                    scope.displayModel =  currentModel;
                    ngModelCtrl.$setViewValue(currentModel);
                });

                scope.$on('$destroy', function() {
                    inputDom.spectrum('destroy');
                    inputDomValue.off();
                });
            }
        };
    }
})();